document.addEventListener(
  "click",
  function(event) {
    if (!event.target.matches(".button--anchor")) return;

    event.preventDefault();

    var hash = event.target.hash;

    const content = document.querySelector(hash);

    if (content === null) {
      return;
    }

    window.scrollTo({ top: content.offsetTop + 50, behavior: "smooth" });
  },
  false
);
